import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';

import { performAction } from '../../actions';
import { carcollectCreate, setVehicleProperties, setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_CAR_COLLECT, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './HILT.module.css';
import { getPropByName } from '../../../../utils/props';
import { CarcollectCredentialModal } from '../../../Vehicles/components/CarcollectCredentialModal';
import { selectConfig } from '../../../Api/selectors';

const TASK_REMARK_TYPE = 'task_HILT_advertise_combine';
const StyledContainer = styled.div`
  .modal-inner {
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-4 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
  showCredentialModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class HILT_advertise_combineComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.setState({
      HILT_bid_sum: getPropByName(this.props.vehicle, 'HILT_bid_sum'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle != this.props.vehicle) {
      this.setState({
        HILT_bid_sum: getPropByName(this.props.vehicle, 'HILT_bid_sum'),
      });
    }
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get tripleCheckProps() {
    let props = ['task_HILT_bid_acceptable'];
    return props;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //approve BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = true;
    this.vehicle.carcollect_tradedossier_id && (disable = false);
    return disable;
  }

  handleCreateClick = () => {
    const { config } = this.props;
    
    // Check if there are multiple credentials available
    if (config?.carcollectCredentials?.length > 0) {
      this.setState({ showCredentialModal: true });
    } else {
      // No credentials or single credential - proceed directly
      this.props.create(() => {
        this.setState({ showAddCarcollect: false, showCarcollectAddMessage: true });
      });
    }
  }

  handleCredentialConfirm = (credentialId) => {
    this.setState({ showCredentialModal: false });
    this.props.create(() => {
      this.setState({ showAddCarcollect: false, showCarcollectAddMessage: true });
    }, credentialId);
  }

  handleCredentialCancel = () => {
    this.setState({ showCredentialModal: false });
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 || val == 4 ? 4 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
            {/*<div className="check">{state == 0 ? '-' : state == 1 ? '+' : 'x'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  update(status) {
    let properties = [];
    if (status == '1') {
      properties?.push({
        propertyName: 'task_HILT_auction',
        propertyValue: '1',
      });
    }

    if (status == '2') {
      properties?.push({
        propertyName: 'task_HILT_redeployment_online',
        propertyValue: '1',
      });
    }

    if (status == '3') {
      properties?.push({
        propertyName: 'task_HILT_shortlease_fulfilled',
        propertyValue: '1',
      });
    }

    this.props.updateVehicleProperties(this.props.vehicle?.id, properties);

    if (status == '3') {
      this.props.update(this.vehicle.id, 'task_HILT_shortlease_fulfilled', () => {
        // Do not set approve to 'null' here
      });
    }
    if (status == '2') {
      this.props.update(this.vehicle.id, 'task_HILT_redeployment_online', () => {
        // Do not set approve to 'null' here
      });
    }
    if (status == '1') {
      this.props.update(this.vehicle.id, 'task_HILT_auction', () => {
        // Do not set approve to 'null' here
      });
    }
  }

  renderEditableVehicleFields() {
    return (
      <VBox>
        {['HILT_advertise_sum'].map(prop => {
          return (
            <HBox key={prop} vCenter gap={'8px'}>
              {/* <HBox> */}
              {this.lbl(`vehicle.property.${prop}`)}
              <VehiclePropertyLoadable name={prop}>
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      type={prop}
                      value={this.state[prop]}
                      onChange={this.onInputChange.bind(this)}
                      name={prop}
                      key={prop}
                      onBlur={() => {
                        this.state[prop] && this.props.setProperty(prop, this.state[prop]);
                        console.log('onBlur', this.state[prop]);
                      }}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>€</div>
                </div>
              </VehiclePropertyLoadable>
              {/* </HBox> */}
            </HBox>
          );
        })}
      </VBox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>

          <StyledContainer>
            <VBox className="manco-list" key="manco">
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                disabled={this.vehicle.carcollect_tradedossier_id}
                onClick={() => this.setState({ showAddCarcollect: true })}
              >
                {this.vehicle.carcollect_tradedossier_id
                  ? this.lbl('carcollect.submitted')
                  : this.lbl('vehicle.property.carcollect')}
              </ButtonComponent>
              {this.state.showCarcollectAddMessage && (
                <HBox left vCenter gap={'8px'}>
                  <Loader small /> <span>{this.lbl('carcollect.add_message')}</span>
                </HBox>
              )}
              <br />
              {this.state.showAddCarcollect && (
                <>
                  <ButtonComponent
                    style={'ButtonSoftPrimary'}
                    onClick={this.handleCreateClick}
                  >
                    {this.lbl('create')}
                  </ButtonComponent>

                  <br />
                </>
              )}
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                // disabled={this.getTaskStatus() == '1'}
                onClick={() => this.update('3')}
              >
                {this.lbl('vehicle.property.shortlease')}
              </ButtonComponent>
              <br />
              <ButtonComponent
                style={'ButtonSoftPrimary'}
                // disabled={this.getTaskStatus() == '2'}
                onClick={() => this.update('4')}
              >
                {this.lbl('vehicle.property.redeployment_online')}
              </ButtonComponent>
              notes: workflow omzetten moet nog worden ontwikkeld, shortlease is hier dat hij weer is ingezet en de volgende
              stap in gaat
            </VBox>
          </StyledContainer>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            // disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>

        {this.state.showCredentialModal && (
          <CarcollectCredentialModal
            onConfirm={this.handleCredentialConfirm}
            onCancel={this.handleCredentialCancel}
          />
        )}
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <StyledContainer>
          <VehicleHeader vehicle={vehicle} kanbanCell />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </StyledContainer>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HILT_advertise_combineComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
    workCarcollect: selectWork(REQUEST_CAR_COLLECT),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(callback, credentialId) {
      dispatch(carcollectCreate(ownProps.cell.vehicle.id, callback, credentialId));
    },
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    updateVehicleProperties(vehicleId, properties, callback) {
      dispatch(setVehicleProperties(vehicleId, properties, callback));
    },
    update(vehicle_id, property, callback) {
      dispatch(
        setVehicleProperty(vehicle_id, property, '1', result => {
          callback?.();
          ownProps.onChange?.(); // Safe call
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HILT_advertise_combine = compose(withConnect, withRouter)(HILT_advertise_combineComp);
